import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  doesClientExistAsync,
  setReasons,
  setReasonsExplanation,
  setHealthChange,
} from "../../store/bookingSystemSlice";

function ReasonsExplanation() {
  const dispatch = useDispatch();
  const { reasons, reasonsExplanation } = useSelector(
    (state) => state.bookingSystem,
  );

  if (reasons["Specific Problem"] === true) {
    return (
      <textarea
        rows="3"
        className="enter-details-input enter-details-long-text"
        spellCheck={false}
        placeholder="Explain the above answer *"
        value={reasonsExplanation}
        onChange={(e) => dispatch(setReasonsExplanation(e.target.value))}
      />
    );
  }

  return <br />;
}

function IntakeForm() {
  const dispatch = useDispatch();
  const {
    intakeFormExists,
    firstName,
    lastName,
    email,
    phone,
    reasons,
    healthChange,
  } = useSelector((state) => state.bookingSystem);

  useEffect(() => {
    if (intakeFormExists === null) {
      dispatch(doesClientExistAsync(firstName, lastName, email, phone));
    }
  }, [intakeFormExists, dispatch, firstName, lastName, email, phone]);

  const chooseReason = (label) => {
    const updatedReasons = Object.keys(reasons).reduce((result, key) => {
      result[key] = key === label;
      return result;
    }, {});
    dispatch(setReasons(updatedReasons));
    if (label !== "Specific Problem") {
      dispatch(setReasonsExplanation(""));
    }
  };

  if (intakeFormExists === null) {
    return <span>Checking if client exists...</span>;
  }

  return (
    <React.Fragment>
      <span className="bold medium">Enter your details</span>

      <span>
        Reasons for seeking Massage Therapy:{" "}
        <span style={{ color: "red" }}>*</span>{" "}
      </span>
      <div className="flex-column" style={{ gap: "10px" }}>
        {Object.keys(reasons).map((option) => (
          <div key={option}>
            <input
              type="radio"
              id={`visit-reason-${option}`}
              name="visit-reason"
              checked={reasons[option] === true}
              onChange={() => chooseReason(option)}
              style={{ cursor: "pointer" }}
            />
            <label
              style={{ cursor: "pointer", userSelect: "none" }}
              htmlFor={`visit-reason-${option}`}
            >
              {option}
            </label>
          </div>
        ))}
      </div>

      <ReasonsExplanation />

      {intakeFormExists === true && (
        <React.Fragment>
          <span>
            Health change since last time?{" "}
            <span style={{ color: "red" }}>*</span>
          </span>
          <div className="flex-column" style={{ gap: "10px" }}>
            <div>
              <input
                type="radio"
                id="health-change-yes"
                name="health-change"
                checked={healthChange === true}
                onChange={() => dispatch(setHealthChange(true))}
                style={{ cursor: "pointer" }}
              />
              <label
                style={{ cursor: "pointer", userSelect: "none" }}
                htmlFor="health-change-yes"
              >
                Yes
              </label>
            </div>
            <div>
              <input
                type="radio"
                id="health-change-no"
                name="health-change"
                checked={healthChange === false}
                onChange={() => dispatch(setHealthChange(false))}
                style={{ cursor: "pointer" }}
              />
              <label
                style={{ cursor: "pointer", userSelect: "none" }}
                htmlFor="health-change-no"
              >
                No
              </label>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

export default IntakeForm;
